import { useEffect, useState } from 'react';
import '../stylesheets/Timeline.css';

const Timeline = () => {
    const [exp, setExp] = useState([])

    useEffect( () => {
        setExp([

            {
                title: "PhD in NLP",
                time: "Sept 2026 - Present",
                location: "University of Toronto",
                logo_url: "/images/uoft.png",
                details: [
                    "Pursuing a PhD in Mechanistic Interpretability within Computational Linguistics under the supervision of Dr. Gerald Penn.",
                ],
            },

            {
                title: "Machine Learning Engineer",
                time: "Aug 2026 - Present",
                location: "Pinterest",
                logo_url: "/images/pinterest-logo.png",
                details: [
                    "Content Qualilty Team"
                ],
            },
            {
                title: "MSc in NLP",
                time: "2024 - 2026",
                location: "University of Toronto",
                logo_url: "/images/uoft.png",
                details: [
                    "Completed a Master's in Computational Linguistics under the supervision of Dr. Gerald Penn.",
                    "Thesis is linked above."
                ],
            },
            {
                title: "Machine Learning Researcher",
                time: "Summer 2025",
                location: "Internship | Pinterest",
                logo_url: "/images/pinterest-logo.png",
                details: [
                    "Improving upon SOTA models by 79% and pioneering",
                    "Shipping models to 32M+ users",
                    "Pioneering infrastructure for VLM Fine-Tuning company-wide",
                    "https://medium.com/pinterest-engineering/improving-quality-of-recommended-content-through-pinner-surveys-eebca8a52652"
                ],
            },
            {
                title: "Machine Learning Engineer",
                time: "Summer 2024",
                location: "Enginable",
                logo_url: "/images/enginable.png",
                details: [
                    "Built an enterprise level agentic automation system for our largest client, cutting 30+ hours of work to mere minutes",
                    "Lead client conversations translating business requirements to engineering plans, so I could deliver real impact"
                    ],
            },
            {
                title: "Systems Researcher",
                time: "Spring 2024",
                location: "Internship | embARC",
                logo_url: "/images/uoft.png",
                details: [
                    // "I was a research intern under the supervision of Dr. Nandita Vijaykumar in her research group, embARC.",
                    "I used GPU profilers (Nsight Systems) to analyze the memory transfer during RL training inside Nvidia's Isaac Gym",
                    "I also learned about task planning and SLAM systems for automated chemistry labs"
                ],
            },
            {
                title: "Operations and Development",
                time: "Fall 2023",
                location: "Koala Studios",
                logo_url: "/images/koala_small.png",
                details: [
                            "Lead our sales and marketing strategy, closed multiple clients in 2 months",
                            "Built the blog infrastructure",
                        ],
            },
            {
                title: "Software Engineer",
                time: "Summer 2023",
                location: "Internship | Steamlabs",
                logo_url: "/images/steamlabs.png",
                details: [
                            "Designed and built a new navigation & tracking system feature for the main project used by hundreds",
                            // "Directly implemented new features in response to direct user feedback and testing, and demonstrated to our client to great success",
                            "My new feature introduced new cross-story dynamic functionality into Twine-based games"
                        ],
            },
            {
                title: "Founder",
                time: "2022 - 2023",
                location: "Mathamoo",
                logo_url: "/images/mathamoologo.png",
                details: [
                            "I developed a new program for mathematics centred around learning how to learn",
                            "All students reported notable academic improvement.",
                        ],
            },
            {
                title: "Solutions Associate",
                time: "Summer 2022",
                location: "Deloitte",
                logo_url: "/images/deloitte.png",
                details: [
                    // "Built frontend design from figma mock-up for AI / big data internal project using React",
                    "Founded the CDC Learning Community of over 90 members across Deloitte Montreal",
                    "Trained and certified myself in Azure and Databricks ahead of schedule by 5 days and taught others as well",
                    // "Synthesized then created documentation for solutions using Azure Data Factory and Azure Synapse Pipelines",
                ]
            },
            {
                title: "Data Scientist",
                time: "Summer 2021",
                location: "Internship | University of Toronto - Social Science Research Team",
                logo_url: "/images/uoft.png",
                details: [
                    // "Interned for a social science research team to use programming to help them understand tools and produce data",
                    "Used AI APIs to review massive datasets, cutting time from 60+ hours to mere minutes",
                    "Saved the team 3+ hours by mass-producing datasets through script automation and creating custom plots for analysis",
                    // "Utilized phonetic analysis libraries to assess AI transcription software computationally, optimizing the duration of the task from 50 minutes to under 10 seconds",
                ]
            },
            {
                title: "Software Engineer",
                time: "Summer 2021",
                location: "Internship | University of Toronto - CS Dept.",
                logo_url: "/images/uoft.png",
                details: [
                    // "Interned for the SDS team at UofT to maintain and upgrade the school’s marking software",
                    "Improved quality of the code by utilizing react-chartjs2 library and reducing code needed", // (Ruby & React)", 
                    "Solved bugs to improve user experience, utilized by thousands of users",
                    // "Solved bugs such as missing columns when downloading CSV grades reports improving user experience for TAs. My changes are currently utilized by thousands of students, and hundreds of TAs",
                ]
            },
            {
                title: "Bachelor's Degree",
                time: "2020 - 2024",
                location: "University of Toronto",
                logo_url: "/images/uoft.png",
                details: [
                            "HBSc Computer Science Specialist & Mathematics Major",
                            "4.0 GPA"
                        ],
            },
        ])
    }, [])
    return <>
        <section id='timeline'>
            <div className="timeline-wrapper">
                <h2 className='timeline-header'>Experience </h2>
                <div className="timeline-content">
                    <div className='progressbar'>
                        <div className='progressbar-white'></div>
                    </div>
                    <div className='experience-wrapper'>
                        {exp?.map((item, idx) => {
                            return (
                                <div key={idx} className='experience'>
                                        <div className="experience-left">
                                            <p className="experience-time">{item.time}</p>
                                            <div className='bubble'></div>
                                        </div>
                                        <div className='experience-right'>
                                            <img src={item.logo_url} alt="logo"></img>
                                            <div className='experience-right-right'>
                                                <h2>{item.title}</h2>
                                                <p className="experience-loc">{item.location}</p>
                                                <ul>
                                                    {item.details.map((detail, index) => <li key={index}>{detail}</li>)}
                                                </ul>
                                            </div>
                                        </div>
                                </div>
                            )
                        })}
                    </div>  
                </div>
            </div>
        </section>
    </>;
}

export default Timeline;